import { InputField } from "components/InputField/Input";
import { CommonButton } from "components/Buttons/Buttons";
import { BiMinus, BiPlus } from "react-icons/bi";
import useItemDropdown from "./useItemDropdown";
import { dropdownFunction } from "utilities/dropdownFunction";

const useSAUDataTable = (formik, setDeleteSAUID, setShowDeleteSAUModal) => {
    const addItemOnChange = (e, i, fieldName) => {
        formik.setFieldValue(`sau[${i}].${fieldName}`, e?.value || e?.target?.value);
    };

    const {
        departmentDropdown, 
        setDepartmentDropdown, 
        employeeNameDropdown,
        setEmployeeNameDropdown,
        unitListDropdown,
        setUnitListDropdown,
        departmentList,
        employeeNameList,
        unitList,
    } = useItemDropdown();

    const modalSAUTableColumns = [
        {
            field: "unit",
            header: "Unit",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="unit"
                        name="unit"
                        autoFilteredValue={unitListDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setUnitListDropdown, unitList)}
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "unit")}
                        value={formik.values.sau[event.rowIndex]?.unit}
                        type="select"
                        label="Select Unit"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        errors={formik.errors.sau?.[event.rowIndex]?.unit}
                    />
                </div>
            ),
        },
        {
            field: "department",
            header: "Department",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="department"
                        name="department"
                        autoFilteredValue={departmentDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setDepartmentDropdown, departmentList)}
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "department")}
                        value={formik.values.sau[event.rowIndex]?.department}
                        type="select"
                        label="Select Department"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        errors={formik.errors.sau?.[event.rowIndex]?.department}
                    />
                </div>
            ),
        },
        {
            field: "contact_person",
            header: "Contact Person",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="contact_person"
                        name="contact_person"
                        autoFilteredValue={employeeNameDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setEmployeeNameDropdown, employeeNameList)}
                        onChange={(e) => addItemOnChange(e, event.rowIndex, "contact_person")}
                        value={formik.values.sau[event.rowIndex]?.contact_person}
                        type="select"
                        label="Select Contact Person"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        errors={formik.errors.sau?.[event.rowIndex]?.contact_person}
                    />
                </div>
            ),
        },
    ]

    const deleteSAUItems = (rowData) => {
        const {id, asset} = rowData;
        setDeleteSAUID({id, asset})
        setShowDeleteSAUModal(true)
    }

    const modalSAUTableActionButton = (rowData, {rowIndex}) => {
        const handleOnFieldIncrement = () => {
            const joinData = formik.values.sau.concat({
                fieldId: rowIndex + 1,
                id: 0,
                unit: "",
                department: "",
                contact_person: "",
            });
            formik.setFieldValue("sau", joinData)
        };

        const handleOnFieldDecrement = (i) => {
            if(rowData.id > 0){
                return deleteSAUItems(rowData)
            }
            const removeData = [...formik.values.sau];
            removeData.splice(rowIndex, 1);
            formik.setFieldValue("sau", removeData);
        };

        return (
            <>
                <div className="flex items-center justify-center">
                    {
                        formik.values.sau.length - 1 === rowIndex ? (
                            <>
                                <CommonButton 
                                    icon={<BiPlus className="text-green-700 text-2xl" />}
                                    className="p-button-rounded p-mr-2 action-button-green"
                                    title=""
                                    type="button"
                                    onClick={handleOnFieldIncrement}
                                />
                                {formik.values.sau.length !== 1 && 
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />}
                            </>
                        ) : 
                        (
                            <>
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />
                            </>
                        )
                    }
                </div>
            </>
        )
    }

    return {
        modalSAUTableColumns,
        modalSAUTableActionButton,
    }
}

export default useSAUDataTable